var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPrintpdf = function SvgPrintpdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "8k6i7nkhia",
    d: "M0 0L20.651 0 20.651 20.65 0 20.65z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-882 -2759) translate(882 2759)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bc98bj2psb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8k6i7nkhia"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#15152A",
    d: "M3.869 1.196c-1.474 0-2.673 1.2-2.673 2.672v12.914c0 1.474 1.199 2.673 2.673 2.673h7.386c.168-2.299 1.3-4.384 3.165-5.79 1.455-1.096 3.226-1.65 5.035-1.601V3.868c0-1.473-1.199-2.672-2.672-2.672H3.869zm8.56 19.454h-8.56c-2.134 0-3.87-1.735-3.87-3.868V3.868C0 1.735 1.735 0 3.87 0h12.914c2.133 0 3.868 1.735 3.868 3.868v9.507l-.665-.073c-1.693-.195-3.456.272-4.846 1.319-1.723 1.299-2.711 3.278-2.711 5.432v.597z",
    mask: "url(#bc98bj2psb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M22.242 19.915l-2.365 2.549V16.18c0-.317-.259-.576-.575-.576-.317 0-.575.259-.575.576v6.283l-2.383-2.55c-.218-.23-.586-.247-.817-.028-.23.219-.247.581-.028.811l3.366 3.619c.109.115.259.184.42.184.161 0 .31-.069.42-.184l3.371-3.619c.219-.23.208-.598-.022-.811-.237-.22-.593-.201-.812.029",
    transform: "translate(-882 -2759) translate(882 2759)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.29 13.21c-3.774 0-6.844 3.07-6.844 6.842 0 3.773 3.07 6.843 6.843 6.843s6.842-3.07 6.842-6.843c0-3.772-3.069-6.842-6.842-6.842m0 14.79c-4.382 0-7.948-3.565-7.948-7.948 0-4.382 3.566-7.947 7.948-7.947 4.383 0 7.947 3.565 7.947 7.947 0 4.383-3.564 7.948-7.947 7.948M4.778 6.365h5.968c.324 0 .59-.265.59-.59 0-.323-.266-.589-.59-.589H4.778c-.324 0-.588.266-.588.59 0 .324.264.589.588.589M5.109 9.217h9.315c.507 0 .92-.265.92-.59 0-.323-.413-.589-.92-.589H5.11c-.506 0-.92.266-.92.59 0 .324.414.589.92.589",
    transform: "translate(-882 -2759) translate(882 2759)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrintpdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/printpdf.ac88e547.svg";
export { ForwardRef as ReactComponent };